import { Signal } from '@angular/core';

export abstract class ForgotPinStoreFactory {
  abstract loading$: Signal<boolean>;
  abstract error$: Signal<string | null>;
  abstract userStep: Signal<'create-pin' | 'confirm-pin' | 'done'>;
  abstract next(pin: string): Promise<void>;
}
